<template>
    
</template>

<script>
import { mapActions } from 'vuex';
export default {
    methods: {
        ...mapActions('auth', [
        'destroyToken', // -> this.foo()
      ]),
        
    },
    created() {
        this.destroyToken()
            .then(() => {
                this.$router.push({ name: 'Login' })
            })
    }
}
</script>